import qs from 'qs'
import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import { PAGES } from './const'
import { pageApiRes, pageApiTypes } from './interfaces'

class PagesApi implements apiInterface.IPagesApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  /**
   * TODO перейти на React-router
   * */

  getPage = async (
    pathname: string,
    queryParams = {},
    axiosParams = {}
  ): Promise<{ pageType: string; page: pageApiTypes.IInitState }> => {
    try {
      const res = await this.ctx.get<unknown, pageApiRes.IGetPageRes>(
        `/pages/${pathname}`,
        queryParams,
        {
          ...axiosParams,
          paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
        }
      )
      const page = res.data
      const serializer = PAGES[page.page_model]
      return { pageType: page.page_model, page: serializer(page) }
    } catch (error: any) {
      return { pageType: error.response.status, page: {} as pageApiTypes.IInitState }
    }
  }
}

export default PagesApi
